"use strict";
exports.__esModule = true;
exports["default"] = (function (input) { return /.{8,}/i.test(input); });
